import { render, staticRenderFns } from "./IPInput.vue?vue&type=template&id=4f658bac&"
import script from "./IPInput.vue?vue&type=script&lang=ts&"
export * from "./IPInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports